export default __webpack_public_path__ + "static/media/cli-retiro-pedras.2fbee094.jpg";